import { TextField } from '@superops/ui-design-system';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';

const TimeUnitWrapper = styled.div`
  .Polaris-TextField {
    margin-bottom: 0px !important;
    max-width: 40px !important;
  }
  . unit-label {
    line-height: 20px;
  }
`;

/**
 * Calculates time based on string and populates value in text field.
 * Calculates the minutes based on hours and minutes.
 * Returns a string based on the total minutes entered.
 */

function TimeUnit(props) {
  const { el } = props;
  const getHours = (duration) => {
    const hours = Math.floor(duration / (1000 * 60 * 60));
    return hours;
  };
  const getMinutes = (duration) => {
    const minutes = Math.floor((duration / (1000 * 60)) % 60);
    return minutes;
  };
  const timeSpent = Math.ceil(el.qty * 60);
  const hours = getHours(timeSpent * 60000)?.toString();
  const minutes = getMinutes(timeSpent * 60000)?.toString();
  const handleDurationChange = (type, val, totalTime) => {
    const mins = getMinutes(totalTime);
    const hrs = getHours(totalTime);
    let updatedQuantity = hrs * 60 + mins;
    switch (type) {
      case 'hours':
        updatedQuantity = Number(val) * 60 + mins;
        break;
      case 'minutes':
        updatedQuantity = Number(hrs) * 60 + Number(val);
        break;
      default:
        break;
    }
    props.updateQuantity(el, updatedQuantity / 60);
  };
  return (
    <TimeUnitWrapper className="flex center">
      <div className="ml8 mr8">
        <TextField
          value={hours}
          onChange={(val) => {
            handleDurationChange('hours', val, timeSpent * 60000);
          }}
          type="number"
        />
        <div className="fs10 uppercase unit-label">
          <FormattedMessage id="ticket.details.worklog.hrs" />
        </div>
      </div>
      <div className="align-self-start disabled">:</div>
      <div className="ml8 mr8">
        <TextField
          value={minutes}
          onChange={(val) => {
            handleDurationChange('minutes', val, timeSpent * 60000);
          }}
          type="number"
        />
        <div className="fs10 uppercase unit-label">
          <FormattedMessage id="ticket.details.worklog.min" />
        </div>
      </div>
    </TimeUnitWrapper>
  );
}

export default TimeUnit;
